import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) =>
	({
		fab: {
			position: 'fixed',
			bottom: 24,
			left: 24,
			backgroundColor: theme.palette.primary.main,
			color: 'white',
			zIndex: 1201,
		},
		icon: {
			fontSize: 40,
		},
	} satisfies Record<string, CSSObject>);
